import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { urls } from 'helpers/url';
import { navigate } from 'actionCreators';
import { updatePhaseTask } from 'actionCreators/phase';
import PhaseTask from './phase_task';
import PhaseType from 'types/phase';
import TaskType from 'types/task';

export class CheckOutOFStore extends PhaseTask {
  isDisabled = () => false

  onClick = () => {
    if (this.props.task.status !== 'complete') {
      this.handleClose();
      this.props.navigate(urls.phaseMaterialsChecklist(this.props.phase));
    } else this.toggleStatus();
  }
}

CheckOutOFStore.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
};

export const check_out_of_store = connect(() => state => ({ user: state.user }),
  { updatePhaseTask, navigate })(CheckOutOFStore);




// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/check_out_of_store.jsx